import axios from 'axios';
import { saveAs } from 'file-saver';
import { getHostKey } from './RestUrls';
import { getToken } from '../util/authUtil';

export interface IHeader {
  [key: string]: string;
}

const getAccessToken = async () => {
  return await getToken();
}

export const getHeaders = async () => {
  const token = await getAccessToken();
  const header: IHeader = {};
  header['Access-Control-Allow-Origin'] = '*';
  header['Authorization'] = `Bearer ${token}`;
  return header;
}

// Fetch example, we want to rather use Axios below so maybe remove this
export const GET = async (url: string) => {
  const init: RequestInit = {
    headers: await getHeaders(),
    method: 'GET'
  }
  const result = await fetch(url, init);
  if (result.status === 200) {
    return await result.json();
  } else {
    // TODO: error handling
    console.log('result', result);
  }
}

// AXIOS -->

/**
 * Adds /?code=[Azure_host_key] to url if it is missing
 */
export const fixUrl = (url: string) => {
  let fixedUrl = url;
  if (!url.includes('?code=')) {
    fixedUrl = `${url}?code=${getHostKey()}`
  };
  return fixedUrl;
}

export const get = async (url: string, params: any = {}) => {
  try {
    const config = {
      headers: await getHeaders(),
      params: params
    }
    const result = await axios.get(fixUrl(url), config);
    if (result.status === 200) {
      return result.data;
    } else {
      console.log('Request failed, status', result.status);
      return null;
    }
  } catch (error: any) {
    // error handling? Use growl or something?
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      return error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      return null;
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error %s %s', error.name, error.message);
      return null;
    }
  }
}

export const download = async (url: string, data = null) => {
  try {
    const config = {
      headers: await getHeaders(),
      responseType: 'blob' as 'json'
    }
    let result = null;
    if(!data)
      result = await axios.get(fixUrl(url), config);
    else 
      result = await axios.post(fixUrl(url), data, config);
    if (result.status === 200) {
      let filename = decodeURIComponent(result.request.getResponseHeader('Content-Disposition').split("filename=")[1]);
      saveAs(result.data, filename);
      return filename;
    } else {
      console.log('Request failed, status', result.status);
      return null;
    }
  } catch (error: any) {
    // error handling? Use growl or something?
    console.log(error.response);
    return JSON.parse(await error.response.data.text());
    // return null;
  }
}

export const exporting = async (url: string, data: any) => {
  try {
    const config = {
      headers: await getHeaders(),
      responseType: 'blob' as 'json'
    }
    const result = await axios.post(fixUrl(url), data, config);
    if (result.status === 200) {
      let filename = decodeURIComponent(result.request.getResponseHeader('Content-Disposition').split("filename=")[1]);
      saveAs(result.data, filename);
      return filename;
    } else {
      console.log('Request failed, status', result.status);
      return null;
    }
  } catch (error: any) {
    // error handling? Use growl or something?
    console.log(error.response);
    return JSON.parse(await error.response.data.text());
    // return null;
  }
}

export const put = async (url: string, data: any) => {
  try {
    const config = {
      headers: await getHeaders(),
    }
    const result = await axios.put(fixUrl(url), data, config);
    if (result.status.toString().startsWith('20')) {
      return true;
    } else {
      console.log('Request failed, status', result.status);
      return false;
    }
  } catch (error: any) {
    // error handling? Use growl or something?
    console.log(error.response);
    return false;
  }
}

export const post = async (url: string, data: any) => {
  try {
    const config = {
      headers: await getHeaders(),
    }
    const result = await axios.post(fixUrl(url), data, config);
    if (result.status.toString().startsWith('20')) {
      return result.data;
    } else {
      console.log('Request failed, status', result.status);
      return false;
    }
  } catch (error: any) {
    // error handling? Use growl or something?
    console.log(error.response);
    return error?.response?.data;
  }
}